import React from 'react';
import {Navigate} from 'react-router-dom';
import {LayoutSidebar} from '../../Layout';
import {Spinner} from '../Spinner';
import {useAlertRulesAccess} from '../../context/UserModulesContext';
import {AgencyAlertsConfiguration} from '../agency/settings/AgencyAlertsConfiguration';
import {ALERTS_RULES} from './alertsCenterPaths';

/**
 * `/agency/alerts-configuration` (tanda «Centro de Alertas», F3): con el Centro —el flag de la agencia,
 * viendo la 2.1— la configuración de alertas es «Mis reglas», así que la ruta lleva ahí. Sin el Centro,
 * o en el clásico, monta la pantalla de siempre, igual que antes.
 *
 * Mientras no llegan los módulos no decide: un loader, no la pantalla vieja. El cache de módulos del
 * navegador se aplica DESPUÉS del primer render (el provider arranca vacío), así que montar la de siempre
 * «hasta saber» la dejaba asomar en una carga en frío antes de redirigir (QA-ahora-04).
 */
export function AlertsConfigurationRoute() {
    const {enabled, loaded} = useAlertRulesAccess();
    if (enabled) return <Navigate to={ALERTS_RULES} replace/>;
    if (!loaded) {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <div className="box-loader"><Spinner color="positive"/></div>
                </section>
            </div>
        );
    }
    return <AgencyAlertsConfiguration/>;
}

export default AlertsConfigurationRoute;
